/**
 * vue-i18n locale → 법적 문서 DB LANG 코드 정규화.
 *
 * DB LANG 은 EN / KO / MS / VN / ZH-CN / ZH-TW 6종.
 * vue-i18n locale 은 en / en-GB / en-US / ko / ms / vn / zh-cn / zh-tw 등 다양 →
 * 매칭 안 되면 무조건 EN 으로 폴백.
 */
export function toLegalLang(locale: string | null | undefined): string {
  const l = String(locale || '').toLowerCase().trim();
  if (!l) return 'EN';
  if (l.startsWith('en')) return 'EN';        // en, en-GB, en-US ...
  if (l === 'ko' || l.startsWith('ko')) return 'KO';
  if (l === 'ms' || l.startsWith('ms')) return 'MS';
  if (l === 'vn' || l.startsWith('vi')) return 'VN';
  if (l === 'zh-cn' || l === 'zh-hans' || l === 'zh') return 'ZH-CN';
  if (l === 'zh-tw' || l === 'zh-hant' || l.startsWith('zh-')) return 'ZH-TW';
  return 'EN';
}
